export class ValidationModuleRegistry {
  constructor() {
    this.modules = {};
  }

  registerValidationModule(name, method) {
    if (typeof method !== 'function') {
      throw new Error('Module must be a function type');
    }
    this.modules[name] = method;
  }

  executeValidationModule(name, ...props) {
    if (this.modules[name]) {
      return this.modules[name](...props);
    }
    throw new Error(`Module ${name} not found`);
  }
}
